var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.draggable === false)?_c('div',{staticClass:"gallery"},[_vm._t("default")],2):_c('draggable',{staticClass:"gallery",attrs:{"value":_vm.value},on:{"input":_vm.emitValue}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }